module.exports = [
  {
    url: '/user/page',
    type: 'post',
    response() {
      return {
        success: true,
        code: 1000,
        msg: '操作成功',
        data: {
          pn: 1,
          size: 10,
          total: 10086,
          list: [
            {
              user_id: '100',
              user_name: '麦当劳汉堡',
              account: 'MacDonald',
              gender: 0,
              phone: '1234455555',
              depart_id: '828735811590553600',
              status: 1,
              create_user_id: '100',
              create_time: '2024-01-29 11:00:00',
              update_time: '2024-01-29 11:00:00',
              deleted: 0,
            },
            {
              user_id: '100',
              user_name: '运维账户',
              account: 'yisa',
              gender: 0,
              phone: '18814381111',
              depart_id: '0',
              status: 1,
              create_user_id: '100',
              create_time: '2024-01-29 11:00:00',
              update_time: '2024-01-29 11:00:00',
              deleted: 0,
            },
          ],
        },
      }
    },
  },
  {
    url: '/user/save',
    type: 'post',
    response() {
      return {
        success: true,
        code: 1000,
        msg: '操作成功',
        data: '',
      }
    },
  },
  {
    url: '/user/update',
    type: 'post',
    response() {
      return {
        success: true,
        code: 1000,
        msg: '操作成功',
        data: '',
      }
    },
  },
  {
    url: '/user/delete',
    type: 'post',
    response() {
      return {
        success: true,
        code: 1000,
        msg: '操作成功',
        data: '',
      }
    },
  },
  //角色绑定用户
  {
    url: '/role/user/bind',
    type: 'post',
    response() {
      return {
        success: true,
        code: 1000,
        msg: '操作成功',
        data: '',
      }
    },
  },
  //获取用户的角色
  {
    url: '/role/findByUserId',
    type: 'post',
    response() {
      return {
        success: true,
        code: 1000,
        msg: '操作成功',
        data: {
          role_id: '828757906454216704',
          name: '管理员',
          code: 'admin',
          status: 1,
          remark: '运维角色',
          create_user_id: '100',
          create_time: '2024-01-29 21:52:54',
          update_time: '2024-01-29 21:52:54',
          deleted: 0,
        },
      }
    },
  },
]
